/* eslint-disable react/self-closing-comp */
import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 45 45"
    >
      <path
        fill="#316BA3"
        d="M16.947 3.718c-4.87 0-8.83 3.96-8.83 8.83 0 4.778 3.736 8.645 8.607 8.813.149-.019.298-.019.41 0h.129c4.76-.168 8.496-4.035 8.515-8.812 0-4.871-3.96-8.83-8.83-8.83zM26.391 26.306c-5.187-3.458-13.645-3.458-18.87 0-2.36 1.58-3.662 3.718-3.662 6.004 0 2.287 1.302 4.407 3.644 5.968 2.603 1.748 6.024 2.621 9.444 2.621 3.42 0 6.841-.873 9.444-2.62 2.343-1.581 3.644-3.7 3.644-6.006-.019-2.286-1.301-4.406-3.644-5.967zM37.378 13.646c.297 3.606-2.268 6.767-5.819 7.194h-.093c-.111 0-.223 0-.316.037-1.803.093-3.458-.483-4.703-1.543 1.915-1.71 3.012-4.276 2.788-7.064a8.629 8.629 0 00-1.431-4.053 6.644 6.644 0 012.36-.65c3.645-.317 6.898 2.398 7.214 6.079z"
      ></path>
      <path
        fill="#316BA3"
        d="M41.096 30.842c-.149 1.803-1.301 3.365-3.235 4.424-1.859 1.023-4.201 1.506-6.525 1.45 1.339-1.208 2.12-2.714 2.268-4.313.186-2.305-.91-4.517-3.104-6.283-1.246-.986-2.696-1.766-4.276-2.343 4.108-1.19 9.276-.39 12.455 2.175 1.71 1.376 2.584 3.105 2.417 4.89z"
      ></path>
    </svg>
  );
}

export default Icon;